import type { FunctionComponent, ReactElement } from 'react';

import { JobProfileReviewPrompt } from '../../job-architecture-v2';
import type { ChatContext } from '../chat-context-types';
import { useChatComposerActive } from './ChatComposerContext';

export const ChatPromptOutlet: FunctionComponent = () => {
    const { activeChatContext } = useChatComposerActive();

    if (activeChatContext === null) {
        return null;
    }

    return renderChatPrompt(activeChatContext);
};

const renderChatPrompt = (context: ChatContext): ReactElement => {
    switch (context.kind) {
        case 'job-profile':
            return (
                <JobProfileReviewPrompt
                    architectureId={context.architectureId}
                    itemId={context.itemId}
                    itemType={context.itemType}
                    preferredLanguage={context.preferredLanguage}
                    version={context.version}
                />
            );
    }
};
